import useStyles from "./styles"
// eslint-disable-next-line import/no-cycle
import AutocompleteSearch from ".."
import { GroupByName, restoreNameForBrandOther, sortBrands } from "../../../lib/helper/brandHelper"
import { removeTrailingSlash } from "../../../lib/helper/commonHelper"
import { useLanguage } from "../../../lib/hooks/languageHooks"
import { strings as Localization } from "../../../lib/Localization"
import { useSearchQuery } from "../../../redux/hook/searchHooks"
import { useSteering } from "../../../redux/hook/userHooks"
import { setSearchQuery } from "../../../redux/searchReducer"
import { useGetBrandsQuery } from "../../../redux/services/productInfoApi"
import { setShowNavbarSearch } from "../../../redux/settingsReducer"
import { useGetModelsQuery } from "../../../redux/services/broditWebApi"
import { sortModels } from "../../../lib/helper/modelHelper"
import { Redirect, useLocation, useRouteMatch } from "react-router-dom"
import { useDispatch } from "react-redux"
import React, { useEffect, useState } from "react"
import axios from "axios"
import { DriveEta } from "@material-ui/icons"
import { Box, useMediaQuery } from "@material-ui/core"

function VehicleSearchbar(props) {
    const classes = useStyles()
    const [redirect, setRedirect] = useState(false)
    const [loadingYears, setLoadingYears] = useState(false)
    const [years, setYears] = useState([])
    const { url } = useRouteMatch()
    const location = useLocation()
    const dispatch = useDispatch()
    const vehicleSearchbarSearchQuery = useSearchQuery("vehicleSearchbar")
    const steering = useSteering()
    const language = useLanguage()
    const { data: brands } = useGetBrandsQuery({ language, steering })
    const { data: modelsForSteering } = useGetModelsQuery({ language, steerings: [steering] })
    const isVerySmall = useMediaQuery(theme => theme.breakpoints.down(400))

    const brandTypesNames = [
        "Vehicles"
    ]

    const availableBrands = (brands ?? []).filter(
        brand => brandTypesNames.includes(brand.brandType.name)
    )
    const availableBrandOptions = GroupByName(availableBrands)
    const selectedBrandOptions = availableBrandOptions.filter(
        brandOption => vehicleSearchbarSearchQuery?.brands?.includes(brandOption.name)
    )

    const availableModels = (modelsForSteering ?? []).filter(
        model => selectedBrandOptions
            .map(brandObj => brandObj.name)
            .includes(model.brand)
    )
    const availableModelOptions = GroupByName(availableModels)
    const selectedModelOptions = availableModelOptions.filter(
        modelOption => vehicleSearchbarSearchQuery?.models?.includes(modelOption.name)
    )

    const availableYears = years.map(year => ({ id: year, name: year }))
    const selectedYears = availableYears.filter(
        year => vehicleSearchbarSearchQuery?.years?.includes(year.id)
    )

    const availableYearOptions = GroupByName(availableYears)
    const selectedYearOptions = [
        ...new Set(
            selectedYears.map(year => year.name) ?? []
        )
    ].map(yearName => ({ id: yearName, name: yearName }))

    // Load years from models
    useEffect(() => {
        const models = vehicleSearchbarSearchQuery?.models
        const searchQueryBrands = vehicleSearchbarSearchQuery?.brands
        if (
            models
            && models.length > 0
            && searchQueryBrands
            && searchQueryBrands.length > 0
        ) {
            setLoadingYears(true)
            const getModelYears = (async () => {
                const response = await axios.post(
                    "/api/ProductInfo/GetModelYears",
                    {
                        brandIds: restoreNameForBrandOther(searchQueryBrands),
                        modelIds: models,
                        language: language,
                        steering: [steering]
                    }
                )
                setYears(response.data.response)
                setLoadingYears(false)
            })
            getModelYears()
        }
    }, [vehicleSearchbarSearchQuery?.models])

    useEffect(() => {
        if (Object.entries(vehicleSearchbarSearchQuery).length > 0) {
            dispatch(setSearchQuery({
                type: "vehicleSearchbar",
                value: {
                    ...vehicleSearchbarSearchQuery,
                    steering: [steering]
                }
            }))
        }
    }, [steering])

    useEffect(() => () => {
        setRedirect(false) // Reset redirect on leave
    })

    const handleChangeBrands = (_event, newSelectedOptions) => {
        const brandName = newSelectedOptions?.[0]?.name

        dispatch(setSearchQuery({
            type: "vehicleSearchbar",
            value: {
                ...(brandName) ? {
                    brands: [brandName],
                    steering: [steering]
                } : {}
            },
            clearFilter: true
        }))
    }

    const handleChangeModels = (_event, newSelectedOptions) => { // TODO: Combine with handleChangeBrands
        if (!vehicleSearchbarSearchQuery?.brands) return

        const modelName = newSelectedOptions?.[0]?.name

        dispatch(setSearchQuery({
            type: "vehicleSearchbar",
            value: {
                brands: vehicleSearchbarSearchQuery.brands,
                steering: [steering],
                ...(modelName) ? { models: [modelName] } : {}
            },
            clearFilter: true
        }))
    }

    const handleChangeYears = (_event, newSelectedOptions) => { // TODO: Combine with handleChangeBrands
        if (!vehicleSearchbarSearchQuery?.brands) return
        if (!vehicleSearchbarSearchQuery?.models) return

        const yearIds = newSelectedOptions?.[0]?.value?.map(year => year.id)

        dispatch(setSearchQuery({
            type: "vehicleSearchbar",
            value: {
                brands: vehicleSearchbarSearchQuery.brands,
                steering: [steering],
                models: vehicleSearchbarSearchQuery.models,
                ...(yearIds) ? { years: [...yearIds] } : {}
            },
            clearFilter: true
        }))

        if (yearIds && yearIds.length > 0) {
            dispatch(setShowNavbarSearch(false))
            setRedirect(true)
        }
    }

    const urlToFilterPage = () => `${removeTrailingSlash(url)}/filter`

    return (
        <Box style={{ display: "flex", flexDirection: "column" }} {...props}>
            {
                redirect && location.pathname !== urlToFilterPage()
                && <Redirect to={urlToFilterPage()} />
            }
            <Box
                id="vehicle-searchbar"
                style={{ display: "flex", alignItems: "flex-end", gap: 10 }}
            >
                <DriveEta />
                <AutocompleteSearch
                    className={classes.fieldMargin}
                    style={{ flexGrow: 1 }}
                    id="vehicle-autocomplete-search"
                    // eslint-disable-next-line max-len
                    placeholder={(isVerySmall ? Localization.vehicle : Localization.searchOnVehicle).toUpperCase()}
                    options={sortBrands(availableBrandOptions)}
                    // filterOptions={filterOptions}
                    onChange={handleChangeBrands}
                    selectedOptions={selectedBrandOptions}
                />
            </Box>
            {
                selectedBrandOptions.length > 0
                && (
                    <Box
                        id="vehicle-model-searchbar"
                        style={{ display: "flex", alignItems: "flex-end", gap: 10 }}
                    >
                        <AutocompleteSearch
                            className={classes.fieldMargin}
                            style={{ flexGrow: 1 }}
                            id="vehicle-model-autocomplete-search"
                            placeholder={Localization.searchOnModel}
                            options={sortModels(availableModelOptions)}
                            onChange={handleChangeModels}
                            selectedOptions={selectedModelOptions}
                        />
                    </Box>
                )
            }
            {
                selectedModelOptions.length > 0
                && (
                    <Box
                        id="vehicle-year-searchbar"
                        style={{ display: "flex", alignItems: "flex-end", gap: 10 }}
                    >
                        <AutocompleteSearch
                            className={classes.fieldMargin}
                            style={{ flexGrow: 1 }}
                            id="vehicle-year-autocomplete-search"
                            placeholder={Localization.searchOnModelYears}
                            options={[...availableYearOptions].sort(
                                (a, b) => a.name.localeCompare(b.name)
                            ).reverse()}
                            onChange={handleChangeYears}
                            selectedOptions={selectedYearOptions}
                            loading={loadingYears}
                        />
                    </Box>
                )
            }
        </Box>
    )
}

export default VehicleSearchbar
